import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import QuoteCalculator from "@/components/QuoteCalculator";
import BookingEmbed from "@/components/BookingEmbed";
import ServiceArea from "@/components/ServiceArea";
import Testimonials from "@/components/Testimonials";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-white text-slate-900">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <QuoteCalculator />
        <BookingEmbed />
        <ServiceArea />
        <Testimonials />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
